var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntegrationOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_741_14041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 7.39052V8.00386C14.666 9.44147 14.2005 10.8403 13.3397 11.9917C12.4789 13.1432 11.269 13.9855 9.8904 14.3931C8.51178 14.8007 7.03834 14.7518 5.68981 14.2536C4.34128 13.7554 3.18993 12.8346 2.40747 11.6286C1.62501 10.4225 1.25336 8.9959 1.34795 7.5614C1.44254 6.1269 1.9983 4.76141 2.93235 3.66857C3.8664 2.57574 5.12869 1.81411 6.53096 1.49729C7.93323 1.18046 9.40034 1.32541 10.7135 1.91052M14.6668 2.66671L8.00016 9.34004L6.00016 7.34004",
    stroke: "#16B380",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_741_14041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationOk);
export default __webpack_public_path__ + "static/media/integrationOk.c12dc84fd695ec79f82c949fe6bcc793.svg";
export { ForwardRef as ReactComponent };